import BeautyInsiderMissedRewards from './BeautyInsiderMissedRewards.f';
import { withBeautyInsiderMissedRewardsProps } from 'viewModel/content/BeautyInsider/withBeautyInsiderMissedRewardsProps';

export default withBeautyInsiderMissedRewardsProps(BeautyInsiderMissedRewards);
